import { ProductNameFilter as ReportProductNameFilter } from "./reports/filters/product-name-filter";
import { ProductNameFilter as ReturnsClaimsProductNameFilter } from "./returns-claims/filters/product-name-filter";

export enum ProductNameFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export type ProductNameFilter =
  | ReportProductNameFilter
  | ReturnsClaimsProductNameFilter;
